import type { UrlActionsContext } from '../useUrlActions';

export async function useLogContextAction(
  context: UrlActionsContext,
): Promise<null> {
  // eslint-disable-next-line no-console
  console.log('action context', context);
  return null;
}
